import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const POINT_MENU: PermissionTableRowType = {
  name: '포인트',
  key: 'POINT_MANAGE',
  subRows: [
    {
      name: '포인트 관리',
      key: PERMISSION_SUBJECTS.POINT,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.CREATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.POINT,
          permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ],
        },
        {
          name: '포인트 발급/사유 등록',
          key: PERMISSION_SUBJECTS.POINT,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
      ],
    },
  ],
};
